var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0007 18.3333L21.6673 14.9999M12.084 27.9166L14.9043 27.6032C15.2489 27.5649 15.4212 27.5458 15.5822 27.4937C15.7251 27.4474 15.861 27.3821 15.9864 27.2994C16.1277 27.2062 16.2503 27.0836 16.4954 26.8385L27.5007 15.8333C28.4211 14.9128 28.4211 13.4204 27.5007 12.4999C26.5802 11.5795 25.0878 11.5795 24.1673 12.4999L13.1621 23.5052C12.9169 23.7503 12.7944 23.8729 12.7012 24.0142C12.6185 24.1396 12.5532 24.2755 12.5069 24.4184C12.4548 24.5794 12.4356 24.7517 12.3974 25.0963L12.084 27.9166Z",
    stroke: "#475467",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit2);
export default __webpack_public_path__ + "static/media/edit2.3b6b4b1548b5d0e649a3b6d0f65ffb58.svg";
export { ForwardRef as ReactComponent };